module.exports = __webpack_public_path__ + "static/media/M mall shot 01.edbc0297.webp";